import {useState,useEffect} from 'react'
import { Tooltip } from '@mui/material';
import {  ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../../components/button';
import { toast } from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import SettingsMenu from '../../staticscreens/SettingsMenu';
import DigitalCardMenu from './DigitalCardMenu';
import {AiOutlineEdit,AiOutlineDelete,AiOutlineFileExcel} from 'react-icons/ai'
import { DatePicker, Modal, Select } from 'antd';
import moment from 'moment';
import { DeleteDigitalCardService, DownloadDigitalCardService, GetDigitalCardService } from '../../../services/admin/DigitalCardServices';
import { useSelector } from 'react-redux';
import { GetDigitalCardDistributorSearchService } from '../../../services/admin/DigitalCardDistributorServices';
import {FiChevronRight,FiChevronLeft} from 'react-icons/fi';
import { IconButton } from '@mui/material'
import {BsArrowRepeat} from 'react-icons/bs';

function DigitalCardList() {


    const roles = useSelector(state=>state.Auth.roles)
  
    const [data,setdata] = useState({pagination:{total:0},datas:[]})
    const [selecteddata,setselecteddata] = useState({})
    const [distributors,setdistributors] = useState([])
    const [modal, setModal] = useState(false);
    const navigate = useNavigate()
    const [page,setpage] = useState(1)

    const {pathname} = useLocation();
    const path = pathname.split('/')[1]

    const [step,setstep] = useState({label:'Used',value:1})

    const statusArr = [{label:'Used',value:1},{label:'Pending',value:0},{label:'All Data',value:2}]

      const [search, setsearch] = useState({ text: '', text1: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false,distributor:'' })
    
  
    useEffect(()=>{
        getData(page)
    },[page, step])

    
    

  
  async function getData(page=1){
   const response = await GetDigitalCardService(page,step.value,search.text,search.from_date1,search.to_date1,search.distributor?.value??'')
   setdata(response.data)
  }  

  async function deletedepartment(){
    const response = await DeleteDigitalCardService(selecteddata._id)
    if(response.status === 200){
        setModal(false)
        toast.success(response.data.datas)
        getData(page)
    }
  }

   async function searchData(val,type){
      
        if(type === 'distributor'){
          const response = await GetDigitalCardDistributorSearchService(val,1, '', '', '','All Data','',val)
          let arr = []
          response?.data?.datas?.forEach((d)=>{
            arr?.push({label:d?.name === '' ? ('No name added ' + d?.phone) : d?.name + ' ' + d?.phone,value:d?._id})
          })
          setdistributors(arr)
        }
      }

  async function applyFilter(){
    const response = await GetDigitalCardService(1,step.value,search.text,search.from_date1,search.to_date1,search.distributor?.value??'')
    setdata(response.data)
  }

  async function resetfilter(){
     const response = await GetDigitalCardService(1,step.value,'','','','')
     setdata(response.data)
     setpage(1)
     setsearch({ text: '', text1: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false,distributor:'' })
  }

  async function downloaddata() {
      const response = await DownloadDigitalCardService(1, search?.text1, search?.from_date1, search?.to_date1, '','', search?.text ? search?.text?.data?.standard : '')
      let path = response.data.path.replace('public/', '')
      let url = `${process.env.REACT_APP_BACKEND_IMAGE_URL}${path}`
      window.open(url,'_blank')
      // handleDownload(`${process.env.REACT_APP_BACKEND_IMAGE_URL}${path}`, path.split('/')[path.split('/')?.length - 1])
    }

  return (
    <div className='md:h-screen pt-5 md:pt-0 md:max-h-screen box-border md:overflow-hidden'>
   
     <Modal
        keepMounted
        open={modal}
        onClose={()=>setModal(false)}
        width={300}
        footer={false}
        closable={false}
       
      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <div className='flex justify-end mt-3 '>
            {/* <div className='mr-1 w-full'> */}
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={()=>setModal(false)} />
            {/* </div> */}
            <div  className='ml-2'>
            <ButtonFilledAutoWidth btnName={'Confirm'} onClick={()=>deletedepartment()}  /> 
            </div>
          </div>
        </div>
      </Modal>
        
      <div className='block sm:flex'>
         {path === 'digital_card'  ? <DigitalCardMenu /> : <SettingsMenu />}

        <div className='md:w-[88%] px-4'>
        <div >
        <div className='pt-5'>
        <div className="flex justify-between align-center items-center pb-2 ">
        <span className="font-[800] text-[14px]">Digital Card ({data?.pagination?.total})</span>
 
        <div className='flex flex-wrap items-center'>
          {roles?.includes('admin') &&
            <AiOutlineFileExcel onClick={() => downloaddata()} size={24} className='mx-2 cursor-pointer bg-gray-200 p-1.5' />
          }

          <div className='mr-2 mt-1 md:mt-0'>
            <input id="search_text" placeholder='Search text' type='text' value={search.text} onChange={(e) => setsearch({ ...search, text: e.target.value })} className='border py-[3px] focus:ring-0 focus:outline-0 text-[14px]  w-[100px] px-1 rounded-md border-slate-300' />
          </div>

          <DatePicker size='small' style={{ fontSize: '11px' }} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.from_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, from_date: v, from_date1: v1 }) }} />

          <DatePicker size='small' style={{ fontSize: '11px' }} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.to_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, to_date: v, to_date1: v1 }) }} />

        {roles?.includes('admin') &&
          <div className='mr-2 w-[130px]'>
            <Select 
              showSearch
              filterOption={false}
              value={search?.distributor == '' ? null : search?.distributor}
              bordered={false}
              onSearch={(e) => searchData(e, 'distributor')}
              className='border rounded h-[29px] border-slate-300 w-[100%] place-holder:text-[10px]'
              options={distributors}
              placeholder={<span className="text-[12px] text-gray-300 ">Select Distributor</span>}
              onChange={(e)=>setsearch({...search,distributor:e})}
              />
          </div>}

           <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Reset Filter" onClick={() => resetfilter()} />
              </div>

               <div className='hidden md:flex items-center  text-[12px] mr-2'>

          <h6 className='mr-2 font-[500]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total} </h6>
          <IconButton onClick={resetfilter}><BsArrowRepeat size={16} /></IconButton>

          <div>
          <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}} ><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
          <IconButton onClick={()=>{ page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${data?.pagination?.totalPages === page ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>

          </div>
          </div>

        {roles?.includes('admin') &&
         <ButtonFilledAutoWidth  btnName="Add Digital Card" onClick={()=>navigate('create')} /> 
        }
        </div>


        </div>
        </div>

         <div className='flex mb-2 items-center border-y overflow-x-auto flex-nowrap'>
          {statusArr?.map((s)=>(
          <h6 onClick={()=>{setstep(s);setpage(1)}} className={`font-[600] ${step?.value === s.value && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>{s.label}</h6>
          ))}
        </div>


        {data?.datas?.length === 0 &&
        <div className='grid place-items-center mt-20  items-center justify-center'>
        <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' /> 
        <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
        <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data added based on your current page option please click on add the data button to see list here.</h6>
      </div>
       }

      


        {data?.datas?.length > 0 &&
        <>
       
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 md:max-h-[86vh] md:overflow-y-scroll gap-2 mt-2'>
            {data?.datas?.map((d,i)=>(
            <div key={d?.id}  className='border items-center relative justify-between px-2 py-1 border-b'>
                <h6 className='text-[13px] font-[400] '>Card No : <b>{d.card_no}</b></h6>
                <h6 className='text-[12px] font-[400] '>Days : <b>{d.days}</b></h6>
                <h6 className='text-[12px] font-[400] '>Distributor : <b>{d.distributor?.name || 'No name added'}</b></h6>
                <h6 className={`${d?.used ? 'bg-green-200' : 'bg-blue-200'} p-1 text-[11px]`}>{d?.used ? 'Used' : 'Pending'}</h6>
                {d?.used && d?.customer &&
                <>
                <h6 className='text-[11px] font-[400] mt-1'>Name : <b>{d.customer?.name || 'No name added'}</b></h6>
                <h6 className='text-[11px] font-[400]'>Mobile : <b>{d.customer?.mobile || '-'}</b></h6>
                <h6 className='text-[11px] font-[400]'>Expires On : <b>{d?.createdAt && d?.days ? moment(d.createdAt).add(Number(d.days),'days').format('DD MMM YYYY') : '-'}</b></h6>
                </>}
                <h6 className='text-[10px] font-[400] bg-slate-100 mt-2 p-1'>Created At : <span className='text-[10px] font-[600] leading-normal'>{moment(d.createdAt).format('LLL')}</span> </h6>
                {roles?.includes('admin') &&
                <div className='absolute right-1 bg-white top-1.5 flex'>
                <Tooltip title="Edit" >
                 <span><AiOutlineEdit size={14} className="cursor-pointer" onClick={()=>{navigate('edit',{state:d})}}/></span>
                </Tooltip>
                <Tooltip title="Delete">
                 <span><AiOutlineDelete size={14} className='ml-2 cursor-pointer'  onClick={()=>{setselecteddata(d);setModal(true)}}/></span>
                </Tooltip>
                </div>}
            </div>
            ))}
        </div>
        </>}
          </div>
        </div>
      </div> 
    </div>
  )
}

export default DigitalCardList